import { AxiosStatic } from "axios";
import { PreferredLocale } from "../../utils/locales";
import { AxiosInterceptedResult } from "../interceptors";

interface IMessagesApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

type GetMessagePromise = (accountId: string) => (locale: PreferredLocale) => Promise<AxiosInterceptedResult<string>>;

export interface IMessagesApi {
  getExitCourseExplanation: GetMessagePromise;
  getExitCourseScormExplanation: GetMessagePromise;
  getScormExitPageBodyCourseInProgress: GetMessagePromise;
  getScormExitPageBodyCourseCompleted: GetMessagePromise;
}

export default class MessagesApi implements IMessagesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IMessagesApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getExitCourseExplanation = (accountId: string) => (locale: PreferredLocale) =>
    this.axios.get(`${this.apiRoot}/messages/locale/${locale}/ExitCourseExplanation`, {
      headers: { "Active-User": accountId },
    }) as any;

  public getExitCourseScormExplanation = (accountId: string) => (locale: PreferredLocale) =>
    this.axios.get(`${this.apiRoot}/messages/locale/${locale}/ExitCourseScormExplanation`, {
      headers: { "Active-User": accountId },
    }) as any;

  public getScormExitPageBodyCourseInProgress = (accountId: string) => (locale: PreferredLocale) =>
    this.axios.get(`${this.apiRoot}/messages/locale/${locale}/ScormExitPageBodyCourseInProgress`, {
      headers: { "Active-User": accountId },
    }) as Promise<AxiosInterceptedResult<string>>;

  public getScormExitPageBodyCourseCompleted = (accountId: string) => (locale: PreferredLocale) =>
    this.axios.get(`${this.apiRoot}/messages/locale/${locale}/ScormExitPageBodyCourseCompleted`, {
      headers: { "Active-User": accountId },
    }) as Promise<AxiosInterceptedResult<string>>;
}
